import React from 'react';
import { Form, Row, Col } from 'antd';
import { useQuery } from 'react-query';
import { FormVariableInputList } from '../../ui/molecules/FormVariableInputList';
import { FormBaseSelect } from '../../ui/molecules/FormBaseSelect';

import {
  getOFIEFullReport,
  getOFIEPollutants,
  getOFIEProductionTypes,
  getOFIESources,
  getOFIEVariables,
} from '../../api/OilFatIndustryEmissions';

import { IMethodologyModule, IOFIEFormValues } from './interfaces';

import { getFormResult } from '../../utils/getFormResult';
import { generateReportingVariablesArray } from '../../utils';

export const OilFatIndustryEmissions: React.FC<IMethodologyModule> = ({
  children,
  marginBetween,
}: IMethodologyModule) => {
  const [form] = Form.useForm();

  const productionTypes = useQuery('OFIEProductionTypes', getOFIEProductionTypes);
  const sources = useQuery('OFIESources', () => getOFIESources(form.getFieldValue('production_type')));
  const pollutants = useQuery('OFIEPollutants', () =>
    getOFIEPollutants(form.getFieldValue('production_type'), form.getFieldValue('source')),
  );
  const variables = useQuery('OFIEVariables', getOFIEVariables);

  const onFinish = (values: IOFIEFormValues) => {
    const { production_type, source, pollutant } = values;

    if (variables.data) {
      getFormResult(getOFIEFullReport, {
        productionTypeId: production_type,
        sourceId: source,
        pollutantId: pollutant,
        variables: generateReportingVariablesArray(variables.data, form),
      });
    }
  };

  const onChangeProductionType = () => {
    sources.refetch();
    pollutants.refetch();
  };

  const onChangeSource = () => {
    pollutants.refetch();
  };

  return (
    <Form form={form} onFinish={onFinish}>
      <Row>
        <Col span={11} style={{ marginRight: marginBetween }}>
          <FormBaseSelect
            data={productionTypes.data ? productionTypes.data : []}
            name="production_type"
            cyPrefix={'OFIE'}
            label="Вид производства"
            defaultValue={1}
            onChange={onChangeProductionType}
          />
          <FormBaseSelect
            data={sources.data ? sources.data : []}
            name="source"
            cyPrefix={'OFIE'}
            label="Наименование источника выделения"
            defaultValue={1}
            onChange={onChangeSource}
          />
          <FormBaseSelect
            data={pollutants.data ? pollutants.data : []}
            name="pollutant"
            cyPrefix={'OFIE'}
            label="Наименование вредного вещества"
            defaultValue={1}
            onChange={onChangeSource}
          />
        </Col>
        <Col>
          <FormVariableInputList
            data={variables.data ? variables.data : []}
            cyPrefix="OFIE"
            placeholder="0"
            minValue={0}
            defaultValue={0}
          />
        </Col>
      </Row>
      {children}
    </Form>
  );
};
